export const manifest = {
  screens: {
    scr_iyyusn: { name: "Shaping the Snakker Pilot for Leo Pharma", route: "/", state: {"slideIndex":0}, position: {"x":160,"y":220} },
    scr_partne: { name: "Brands thrive on attention", route: "/", state: {"slideIndex":1}, position: {"x":9960,"y":220} },
    scr_tracti: { name: "Campaign after campaign, market after market", route: "/", state: {"slideIndex":2}, position: {"x":7160,"y":220} },
    scr_whywhe: { name: "A new approach to engagement and conversion", route: "/", state: {"slideIndex":3}, position: {"x":1560,"y":220} },
    scr_jigsaw: { name: "We're the engagement layer", route: "/", state: {"slideIndex":4}, position: {"x":2960,"y":220} },
    scr_techst: { name: "Playing nicely with your tech stack", route: "/", state: {"slideIndex":5}, position: {"x":4360,"y":220} },
    scr_ctower: { name: "Visibility and control, not another project", route: "/", state: {"slideIndex":6}, position: {"x":8560,"y":220} },
    scr_scalin: { name: "Scaling fairly across local markets", route: "/", state: {"slideIndex":7}, position: {"x":5760,"y":220} },
    scr_concer: { name: "Questions worth asking", route: "/", state: {"slideIndex":8}, position: {"x":11360,"y":220} },
    scr_pilots: { name: "Flexible pilot options for Q4", route: "/", state: {"slideIndex":9}, position: {"x":160,"y":2200} },
    scr_closin: { name: "Prove it in Q4. Scale it in 2027.", route: "/", state: {"slideIndex":10}, position: {"x":160,"y":4180} },
  },
  sections: {
    sec_wtb0np: { name: "Engagement Strategy Pitch", x: 0, y: 0, width: 12720, height: 1180 },
    sec_tzw2s9: { name: "Pilot Options", x: 0, y: 1980, width: 4320, height: 1180 },
    sec_5n0qgl: { name: "Close & Next Steps", x: 0, y: 3960, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_wtb0np", children: [
      { kind: "screen", id: "scr_iyyusn" },
      { kind: "screen", id: "scr_whywhe" },
      { kind: "screen", id: "scr_jigsaw" },
      { kind: "screen", id: "scr_techst" },
      { kind: "screen", id: "scr_scalin" },
      { kind: "screen", id: "scr_tracti" },
      { kind: "screen", id: "scr_ctower" },
      { kind: "screen", id: "scr_partne" },
      { kind: "screen", id: "scr_concer" },
    ] },
    { kind: "section", id: "sec_tzw2s9", children: [
      { kind: "screen", id: "scr_pilots" },
    ] },
    { kind: "section", id: "sec_5n0qgl", children: [
      { kind: "screen", id: "scr_closin" },
    ] },
  ],
}
